import React from 'react'
import './p-component.scss'
import { PProps } from '../../types'
import { concatClassName } from '../../utils/helpers'

const P = ({ text, classes, variant, textSize = 'regular' }: PProps) => {
  return <p className={`basic ${concatClassName(classes)} ${variant} ${textSize}`}> {text} </p>
}
export { P }
